import React, { useState } from 'react'
import { FormProvider, useForm } from 'react-hook-form'
import OnboardingStepOne from '../../forms/Onboarding/OnboardingStepOne'
import OnboardingStepTwo from '../../forms/Onboarding/OnboardingStepTwo'
import OnboardingStepThree from '../../forms/Onboarding/OnboardingStepThree'
import { motion } from 'framer-motion'
import { usePostFinishOnboarding } from '../../api/onboarding/usePostFinishOnboarding'
import { queryClient } from '../../api/queryClient'
import { useNavigate } from 'react-router-dom'
import { useGetUser } from '../../api/auth/useGetUser'

export interface OnboardingFormValues {
  first_name: string
  last_name: string
  email: string
  job_title: string
  agency_name: string
  contact_email: string
  billing_email: string
  dealership_name: string
  address: string
  city: string
  state: string
  zip: string
  url: string
}

export default function Onboarding(): JSX.Element {
  const [currentStep, setCurrentStep] = useState(1)
  const navigate = useNavigate()
  const { data: user } = useGetUser()
  const formContext = useForm<OnboardingFormValues>({
    mode: 'onSubmit',
    defaultValues: {
      first_name: user?.first_name ?? '',
      last_name: user?.last_name ?? '',
      contact_email: user?.email ?? '',
      billing_email: user?.email ?? '',
    },
  })
  const { handleSubmit } = formContext
  const { mutateAsync: submitOnboardingDetails } = usePostFinishOnboarding()

  const onSubmit = async (values: OnboardingFormValues) => {
    if (currentStep === 1) {
      setCurrentStep(2)
    }
    if (currentStep === 2) {
      setCurrentStep(3)
    }
    if (currentStep === 3) {
      console.log(values)
      const onboardingResponse = await submitOnboardingDetails(values)
      await queryClient.refetchQueries(['currentUser'])
      navigate(onboardingResponse.next)
    }
  }

  return (
    <div
      className="w-full h-full absolute top-0 left-0 flex flex-col justify-center items-center"
      style={{
        zIndex: 100000,
        backgroundColor: 'rgba(0,0,0,0.5)',
        backdropFilter: 'blur(4px)',
      }}>
      <motion.div className="bg-white rounded-xl shadow-2xl p-10 w-full max-w-3xl">
        <FormProvider {...formContext}>
          <form onSubmit={handleSubmit(onSubmit)}>
            {currentStep === 1 && <OnboardingStepOne />}
            {currentStep === 2 && (
              <OnboardingStepTwo onBackPress={() => setCurrentStep(1)} />
            )}
            {currentStep === 3 && (
              <OnboardingStepThree onBackPress={() => setCurrentStep(2)} />
            )}
          </form>
        </FormProvider>
      </motion.div>
    </div>
  )
}
